import React, { useState, useEffect } from "react";
import GoogleMapReact from "google-map-react";
import { GiPositionMarker } from "react-icons/gi";
import { useSelector } from "react-redux";

function GoogleMapComp({ mapData, locationVal }) {
  console.log(mapData);

  const [coords, setCoords] = useState();
  useEffect(() => {
    if (mapData) {
      var lat_n = parseFloat(mapData?.latitude);
      var lng_n = parseFloat(mapData?.longitude);
      let NewLatLng = { lat: lat_n, lng: lng_n };
      console.log("aa", NewLatLng);
      setCoords(NewLatLng);
    }
  }, [mapData]);

  return (
    <>
      <GoogleMapReact
        bootstrapURLKeys={{ key: "AIzaSyCjulI5lvM_5aEkceTsSZJfYZ-DqguELN4" }}
        defaultCenter={coords}
        center={coords}
        defaultZoom={8}
        margin={[50, 50, 50, 50]}
        options={{ disableDefaultUI: true, zoomControl: true }}
        strokeColor={"#FF0000"}
        strokeWeight={2}
        // onChange={(e) => {
        //   setCoords({ lat: e.center.lat, lng: e.center.lng });
        //   // setBounds({ ne: e.marginBounds.ne, sw: e.marginBounds.sw });
        // }}
        // onChildClick={(child) => setChildClicked(child)}
        yesIWantToUseGoogleMapApiInternals
        // onGoogleApiLoaded={({ map, maps }) => renderPolylines(map, maps)}
        // onGoogleApiLoaded={({ map, maps }) => apiIsLoaded(map, maps)}
      >
        <GiPositionMarker
          lat={mapData?.latitude}
          lng={mapData?.longitude}
          className="marker-points"
        />
      </GoogleMapReact>
    </>
  );
}

export default GoogleMapComp;
